export interface PopularGame {
    name: string;
    uplayGameIds: number[];
}

export default [
    {
        name: "Tom Clancy's The Division 2",
        uplayGameIds: [4932],
    },
    {
        name: "Tom Clancy's Ghost Recon Breakpoint",
        uplayGameIds: [11903],
    },
    {
        name: "Assassin's Creed Odyssey",
        uplayGameIds: [5059],
    },
    {
        name: "Tom Clancy's Rainbow Six Siege",
        uplayGameIds: [635, 1842],
    },
    {
        name: "Anno 1800",
        uplayGameIds: [4553],
    },
    {
        name: "Far Cry 5",
        uplayGameIds: [1803],
    },
    {
        name: "The Crew 2",
        uplayGameIds: [2855],
    },
    {
        name: "Assassin's Creed Origins",
        uplayGameIds: [3539],
    },
    {
        name: "Far Cry: New Dawn",
        uplayGameIds: [5210],
    },
    {
        name: "Watch_Dogs 2",
        uplayGameIds: [2688],
    },
] as PopularGame[];